import { Roles } from '../enums/roles.enum';

export const APPLICATION_ROLES: readonly Roles[] = [
    // Web roles
    Roles.BLOCK_MANAGER_MARKETING,
    Roles.DISTRICT_MANAGER_MARKETING,
    Roles.DISTRICT_PE_MANAGER,
    Roles.STATE_MANAGER_MARKETING,
    Roles.NATIONAL_MANAGER_MARKETING,
    // Mobile roles
    Roles.SHG_BOOKKEEPER,
    Roles.VO_BOOKKEEPER,
    Roles.CLF_BOOKKEEPER,
    Roles.UDYOG_MITRA,
    Roles.BCF,
    Roles.BCIB,
    Roles.BCNF,
];
